import { computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ModuleRouterFacade } from '@kros-sk/router-stores/module-router-store';
import { DocumentPayload } from '@kros-sk/shared-esw/document-view';

/**
 * Submodul verejného received-invoice view — jediný zdroj hodnoty, ktorú app mapuje
 * v PUBLIC_DOCUMENT_SUBMODULES a resolver ukladá do route data.
 */
export const RECEIVED_INVOICE_PUBLIC_SUBMODULE = 'received-invoice-document';

/**
 * B2C doklad = odberateľ bez IČO (fyzická osoba). Vyhodnocuje sa výlučne IČO odberateľa
 * z verejného payloadu — riadi „čistý view" bez reklamy a KROS CTA.
 */
export function isB2CPurchaser(payload: Partial<DocumentPayload> | null | undefined): boolean {
  return !payload?.purchaser?.registrationId?.trim();
}

/**
 * Signál „ide o B2C received-invoice doklad" odvodený z route-resolved dát (rovnaký zdroj
 * ako PublicDocumentViewSchemaDataSource). Zámerne scoped na received-invoice submodul:
 * ostatné typy verejných dokladov (payment ap.) nemajú purchasera v payloade a bez scope
 * by sa mylne tvárili ako B2C. Kým dáta nie sú resolved, vracia false.
 */
export function injectIsB2CReceivedInvoice(): Signal<boolean> {
  const routerFacade = inject(ModuleRouterFacade);
  const routeData = toSignal(routerFacade.data$);

  return computed(() => {
    const data = routeData();
    return (
      data?.['submodule'] === RECEIVED_INVOICE_PUBLIC_SUBMODULE &&
      Object.hasOwn(data, 'document') &&
      isB2CPurchaser(data['document'] as Partial<DocumentPayload> | null | undefined)
    );
  });
}
